import { HeroTitle } from '@components/hero-title'
import Image from '@components/ui/image'
import SmallContainer from '@components/ui/layout/SmallContainer'
import { urlFor } from '@lib/sanity/url-for'
import React, { FC, useEffect, useState } from 'react'
import { AboutUsSingleton } from '__generated__/sanity'
import * as styles from './styles'

type HeroProps = AboutUsSingleton['fields']['hero']

export const Hero: FC<HeroProps> = ({ heroDescription, heroTitle, heroimage }) => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    <>
      <HeroTitle title={heroTitle} description={heroDescription} visible={isMounted} />
      <SmallContainer
        className={styles.imageContainer}
        data-visibility={isMounted ? 'visible' : 'hidden'}
      >
        <Image
          placeholderSrc={urlFor(heroimage).width(20).url()}
          sources={[urlFor(heroimage).width(768).url(), urlFor(heroimage).width(1100).url()]}
          ratio={[0.5]}
          alt=""
        />
      </SmallContainer>
    </>
  )
}
